import axios from "axios";
import Config from "config";

const contact = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/contact`, data)
      .then((res) => resolve(res.data))
      .catch((error) => console.log(error));
  });
};

const deleteAccount = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/delete-account`, data)
      .then((res) => resolve(res.data))
      .catch((error) => console.log(error));
  });
};

export default { contact, deleteAccount };
